import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './FloatingInput.scss';

function FloatingInput({
  label,
  placeholder,
  value,
  name,
  type,
  mask,
  maxLength,
  onChange,
  validate,
  min,
  max,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && validate) {
      inputRef.current.addEventListener('input', () => {
        // Run validation and set error message if needed
        if (validate(inputRef.current.value)) {
          inputRef.current.setCustomValidity('');
        } else {
          inputRef.current.setCustomValidity(
            `Please enter a valid ${label.toLowerCase()}`,
          );
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef, label, validate]);

  return (
    <div className="form-group">
      <label htmlFor={name} className="floating-input-label">
        <div>{value || placeholder ? label : ''}</div>
        <input
          name={name}
          ref={inputRef}
          value={value || ''}
          type={type || 'text'}
          maxLength={maxLength}
          min={min}
          max={max}
          placeholder={placeholder || label}
          onChange={e => {
            if (mask) {
              e.target.value = mask(e.target.value);
            }
            onChange(e);
          }}
          className="form-control floating-input"
          required
        />
      </label>
    </div>
  );
}

FloatingInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  mask: PropTypes.func,
  onChange: PropTypes.func,
  validate: PropTypes.func,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  placeholder: PropTypes.string,
};

export default FloatingInput;
